
import React from 'react';
import { Button } from '@/components/ui/button';
import { useNavigate } from 'react-router-dom';
import { Shield, Users, ArrowLeft } from 'lucide-react';

interface SuperAdminHeaderProps {
  onCreateClick: () => void;
  isDisabled: boolean;
}

const SuperAdminHeader: React.FC<SuperAdminHeaderProps> = ({ onCreateClick, isDisabled }) => {
  const navigate = useNavigate();
  
  return (
    <header className="mb-8">
      <div className="flex flex-col md:flex-row md:items-center md:justify-between">
        <div>
          <h1 className="text-3xl font-bold flex items-center">
            <Shield className="mr-2 h-6 w-6 text-indigo-600" />
            Super Admin Management
          </h1>
          <p className="text-gray-600 mt-1">
            Assign and manage license keys for Super Admins
          </p>
        </div>
        <div className="mt-4 md:mt-0 flex gap-2">
          <Button variant="outline" onClick={() => navigate('/master/dashboard')}>
            <ArrowLeft className="mr-2 h-4 w-4" />
            Back to Dashboard
          </Button>
          <Button onClick={onCreateClick} disabled={isDisabled}>
            Assign License
          </Button>
        </div>
      </div>
    </header>
  );
};

export default SuperAdminHeader;
